
export const API_VERSION = "v2";
export const ICON_SET_BOX= "box";
export const ICON_SET_BLUEPRINT = "bp";
export const ICON_SET_FONTAWESOME = "fa";

export const DESERIALIZE_TYPE_OBJECT = "OBJECT";
export const DESERIALIZE_TYPE_ARRAY_OBJECTS = "ARRAY_OBJECTS";
export const DESERIALIZE_TYPE_CUSTOM = "CUSTOM";

export const COOKIE_EXPIRES_DAYS = 365;

export const COOKIE_ID = "ov_cookie_id";
export const COOKIE_CONTACT_ID = "ov_contact_id";

export const COOKIE_REVIEWS_UPVOTED = "ov_reviews_upvoted";
export const COOKIE_BACKINSTOCK_VISITOR_ID = "ov_backinstock_visitor_id";

export const COOKIE_PROMPT_SESSION_NUM_VIEWED_PAGES = "ov_prompt_session_num_viewed_pages";
export const COOKIE_PROMPT_SESSION_VISITOR_TYPE = "ov_prompt_session_visitor_type";
export const COOKIE_PROMPT_SESSION_FIRST_SEEN = "ov_prompt_session_first_seen";
export const COOKIE_PROMPT_VISITOR_ID = "ov_prompt_visitor_id";
export const COOKIE_PROMPT_LAST_SEEN = "ov_prompt_last_seen";



